import {
  FormGroup,
  Label,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";



const customStyles = {
  multiValueRemove: (styles: any, { data }: any) => ({
    ...styles,
    color: "white",
    backgroundColor: "#405189",
    ':hover': {
      backgroundColor: "#405189",
      color: 'white',
    },
  }),
}

const SelectComponent = ({ formik, label, name, placeHolder, options, value, ...rest }: any) => {
  const { handleChange, touched, values, errors } = formik;
  return (
    <FormGroup className="mb-3">
      <Label htmlFor={name}>{label}</Label>
      <Select
        value={typeof values[name] === 'string' ? options.filter((option: any) => values[name].split(',').includes(option.value)) : values[name]}
        onChange={handleChange}
        placeholder={placeHolder}
        options={options}
        {...rest}
        invalid={touched[name] && !!errors[name]}
        styles={customStyles}
      />
      {touched[name] && errors[name] && (
        <FormFeedback>{errors[name]}</FormFeedback>
      )}
    </FormGroup>
  );
};

export default SelectComponent;
